import React from "react";
import { Link } from "react-router-dom";
import { Plane, Mail, Phone, MapPin } from "lucide-react";
import { useSettings } from "@/lib/settings";

export default function Footer() {
  const { settings } = useSettings();
  return (
    <footer className="bg-[var(--brand-accent)] text-white mt-16">
      <div className="max-w-7xl mx-auto px-6 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-2">
            <div className="w-9 h-9 rounded-xl bg-[var(--brand-primary)] flex items-center justify-center"><Plane className="w-5 h-5" /></div>
            <div className="font-heading font-bold text-lg">{settings.brand_name}</div>
          </div>
          <p className="text-sm text-teal-100/80 mt-4 leading-relaxed">
            Your one-stop B2C travel marketplace for flights, hotels, cars, packages and experiences worldwide.
          </p>
        </div>
        <div>
          <h4 className="font-heading font-semibold mb-3 text-[var(--brand-secondary)]">Explore</h4>
          <ul className="space-y-2 text-sm text-teal-100/80">
            {settings.product_flight !== false && <li><Link to="/flights" className="hover:text-white">Flights</Link></li>}
            {settings.product_hotel !== false && <li><Link to="/hotels" className="hover:text-white">Hotels</Link></li>}
            {settings.product_car !== false && <li><Link to="/cars" className="hover:text-white">Car Rentals</Link></li>}
            {settings.product_package !== false && <li><Link to="/packages" className="hover:text-white">Holiday Packages</Link></li>}
            {settings.product_sightseeing !== false && <li><Link to="/sightseeing" className="hover:text-white">Sightseeing</Link></li>}
          </ul>
        </div>
        <div>
          <h4 className="font-heading font-semibold mb-3 text-[var(--brand-secondary)]">Company</h4>
          <ul className="space-y-2 text-sm text-teal-100/80">
            <li><Link to="/contact" data-testid="footer-link-contact" className="hover:text-white">Contact</Link></li>
            <li><Link to="/about" data-testid="footer-link-about" className="hover:text-white">About</Link></li>
            <li><Link to="/careers" data-testid="footer-link-careers" className="hover:text-white">Careers</Link></li>
            <li><Link to="/press" data-testid="footer-link-press" className="hover:text-white">Press</Link></li>
            <li><Link to="/partners" data-testid="footer-link-partners" className="hover:text-white">Partners</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-heading font-semibold mb-3 text-[var(--brand-secondary)]">Reach us</h4>
          <ul className="space-y-2 text-sm text-teal-100/80">
            <li className="flex items-center gap-2"><Mail className="w-4 h-4" /> {settings.contact_email}</li>
            <li className="flex items-center gap-2"><Phone className="w-4 h-4" /> {settings.contact_phone}</li>
            <li className="flex items-center gap-2"><MapPin className="w-4 h-4" /> {settings.contact_address}</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-5 text-center text-xs text-teal-100/60 space-y-1">
        <div>© {new Date().getFullYear()} {settings.brand_name}. All rights reserved.</div>
        <div data-testid="footer-powered-by" className="text-teal-100/80">{settings.footer_powered_by}</div>
      </div>
    </footer>
  );
}
